/** @format */
import { desktop, largeDesktop } from '@mpb-com/feather/helpers/media-queries';
import { css } from 'styled-components';

import { StyledProductComparisonDisplayProps } from './types';

export const styles = ({
    $productIds,
}: StyledProductComparisonDisplayProps) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    width: 100%;

    .product-comparison-display-heading {
        margin: var(--layout-spacing-40) var(--layout-spacing-32)
            var(--layout-spacing-8);
        text-align: center;
    }

    .product-comparison-display-link {
        margin: 0 var(--layout-spacing-32) var(--layout-spacing-48);
        text-align: center;

        svg {
            font-size: 1.2rem;
            margin-left: var(--layout-spacing-4);
            margin-top: var(--layout-spacing-2);
        }
    }

    .product-comparison-display-constrainer-wrapper {
        width: 100%;
        min-height: 0;
    }

    .product-comparison-display-scrollable-container {
        height: 100%;
        width: 100%;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
    }

    .product-comparison-display-list {
        display: grid;
        grid-template-columns: 0 repeat(
                ${$productIds.length},
                minmax(28rem, 1fr)
            );
        grid-auto-flow: column;
    }

    ${desktop(css`
        .product-comparison-display-list {
            grid-template-columns: auto repeat(
                    ${$productIds.length},
                    minmax(28rem, 1fr)
                );
        }

        .product-comparison-display-scrollable-container {
            width: 100%;
            overflow: auto;
            padding-bottom: var(--layout-spacing-24);
        }
    `)}

    ${largeDesktop(css`
        .product-comparison-display-scrollable-container {
            padding-bottom: var(--layout-spacing-96);
        }
    `)}
`;
